import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule, Router, NavigationEnd } from '@angular/router';



import { WayfindingComponent } from './wayfinding/wayfinding.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { BuscadorComponent } from './buscador/buscador.component';
// import { CineComponent } from './cine/cine.component';
import { EstacionamientosComponent } from './estacionamientos/estacionamientos.component';
import { InformacionesComponent } from './informaciones/informaciones.component';
// import { DondeEstoyComponent } from './donde-estoy/donde-estoy.component';
import { DondeQuieroIrComponent } from './donde-quiero-ir/donde-quiero-ir.component';
// import { MiUbicacionComponent } from './mi-ubicacion/mi-ubicacion.component';
import { TiendasComponent } from './tiendas/tiendas.component';
// import { CineDetalleComponent } from './cine-detalle/cine-detalle.component';
import { TiendaDetalleComponent } from './tienda-detalle/tienda-detalle.component';
import { AreasComponent } from './areas/areas.component';
import { OfertasComponent } from './ofertas/ofertas.component';
import { NewMapComponent } from './new-map/new-map.component';
import { EventoDetalleComponent } from './evento-detalle/evento-detalle.component';
import { QrcodeComponent } from './qrcode/qrcode.component';
import { MensajeQrComponent } from './mensaje-qr/mensaje-qr.component';
// import { DesingTestComponent } from './desing-test/desing-test.component';



declare const componentHandler: any;

const routes: Routes = [

  {path: '', component: BuscadorComponent},

  // {path: '',
  // loadChildren: () => import('./app.module').then(m=> m.BuscadorComponent) },

  { path: 'areas', component: AreasComponent },
  { path: 'buscar/:tipo', component: BuscadorComponent},
  // { path: 'cine', component: CineComponent},
  // { path: 'cine-detalle/:id', component: CineDetalleComponent},
  // { path: 'donde-estoy', component: DondeEstoyComponent},
  { path: 'donde-quiero-ir', component: DondeQuieroIrComponent},
  { path: 'estacionamientos', component: EstacionamientosComponent},
  { path: 'evento-detalle/:id', component: EventoDetalleComponent},
  { path: 'informaciones', component: InformacionesComponent},
  // { path: 'mi-ubicacion/:opt', component: MiUbicacionComponent},
  { path: 'ofertas', component: OfertasComponent },
  { path: 'tiendas', component: TiendasComponent},
  { path: 'tiendas/:tipo', component: TiendasComponent},
  { path: 'mapa/:totem/:piid/:opt/:acc', component: NewMapComponent},
  { path: 'tienda-detalle/:id', component: TiendaDetalleComponent },
  { path: ':totem/:piid/:opt/:acc/:transporte', component: WayfindingComponent },
  { path: 'qrcode/:qrid', component: QrcodeComponent },
  // { path: 'test', component: DesingTestComponent},
  // { path: 'noqr/:qrid', component: MensajeQrComponent },
  { path: 'noqr', component: MensajeQrComponent },
  { path: 'wayfinding/:totem/:piid/:opt/:acc/:transporte', component: WayfindingComponent },
  { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
  providers: [
  ]
})
export class AppRoutingModule {

  constructor(private router: Router) {
    router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {

      }
    });
  }

}
